import { dispatch, ErrorVariants, showToast } from '@zonofi/zono-money-store';

export const processBasicApiResponse = (
  response: any,
  onSuccess: () => void,
  successMessage?: string,
  errorMessage: string = 'Something went wrong'
) => {
  if (response.isSuccess) {
    onSuccess?.();
    if (successMessage) {
      dispatch(
        showToast({
          message: successMessage,
          type: ErrorVariants.SUCCESS,
          canDisplay: true,
          responseStatus: 'Success',
        })
      );
    }
  } else if (response.isError) {
    dispatch(
      showToast({
        message: errorMessage,
        type: ErrorVariants.DANGER,
        canDisplay: true,
        responseStatus: 'Error',
      })
    );
  }
};
